import Link from 'next/link';
import PropTypes from 'prop-types';

import { buttonClickEvent } from '../../helpers/segment';

const Footer = (props) => {
  const { i18n, countryMap, country, page } = props;
  const footer = i18n.t('flight_path');

  return (
    <footer className="footer">
      <p className="f-12 f-semi-bold">
        {footer.disclaimer}
      </p>
      <p className="f-10">
        {footer.this_software_not_intended}
      </p>
      <p className="f-10">{footer.if_in_doubt}</p>
      <p className="f-dark-grey f-normal f-12 text-center">
        {footer.rights_reserved}
        <br />
        {' '}
        <Link
          href="/[lng]/website-terms-and-conditions"
          as={`/${i18n.activeLocale}/website-terms-and-conditions`}
          id="footer-termsconditions-link"
          prefetch={false}
        >
          <a
            role="presentation"
            onClick={() => buttonClickEvent('footer.terms_conditions', 'Terms & Conditions',
              'Footer', page, footer.terms_conditions, countryMap[country])}
            target="_blank"
          >
            {footer.terms_conditions}
          </a>
        </Link>
        {' '}
        |
        {' '}
        <Link href="/[lng]/privacy" as={`/${i18n.activeLocale}/privacy`} prefetch={false}>
          <a
            role="presentation"
            onClick={() => buttonClickEvent('footer.privacy_policy', 'Privacy policy',
              'Footer', page, footer.privacy_policy, countryMap[country])}
            id="footer-privacypolicy-link"
            target="_blank"
          >
            {footer.privacy_policy}
          </a>
        </Link>
      </p>
    </footer>
  );
};

export default Footer;

Footer.propTypes = {
  i18n: PropTypes.shape().isRequired,
  countryMap: PropTypes.shape().isRequired,
  country: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired
};
